import Joyride from 'react-joyride';

import { useTakeTour } from '../../hooks/useTakeTour';
import CustomTooltipComponent from '../CustomTooltipComponent/CustomTooltipComponent';

const TakeTourInitialization = () => {
  const { isOpen, currentStep, steps, stepInProgressState } = useTakeTour();

  return (
    <Joyride
      disableCloseOnEsc
      disableOverlayClose
      // callback={handleJoyrideCallback}
      tooltipComponent={CustomTooltipComponent}
      floaterProps={{
        hideArrow: true,
      }}
      continuous
      run={isOpen}
      stepIndex={currentStep}
      steps={steps}
      scrollOffset={0}
      scrollToFirstStep
      showProgress
      showSkipButton
      styles={{
        options: {
          zIndex: 10000,
          overlayColor: stepInProgressState ? 'rgba(79, 26, 0, 0)' : 'rgba(0, 0, 0, 0.5)',
        },
        overlay: {
          transition: 'all 0.2s ease',
        },
      }}
    />
  );
};

export default TakeTourInitialization;
